import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import SentportfolioReview from "./sentportfolioReview";
import AddportfolioReview from "./addportfolioReview";
import PendingportfolioReview from "./portfolioReview/pendingportfolioReview";
import { useHistory, Link, useLocation } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function PortfolioReview() {
  const location = useLocation();

  // The below code helps to come back to Pending Reviews from the child page of pending reviews that is the second tab
  const navigateTopage = location.state?.navigateTopage;
  const initialTabIndex = navigateTopage === 2 ? 1 : 0;

  // console.log(navigateTopage);

  const classes = useStyles();
  // let match = useRouteMatch();
  const [value, setValue] = useState(initialTabIndex);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    // console.log(newValue, "newValue");
  };

  let tabsList = [
    {
      name: "Sent Reviews",
      child: SentportfolioReview,
    },
    {
      name: "Pending Reviews",
      child: PendingportfolioReview,
    },
    {
      name: "Add Review Request",
      child: AddportfolioReview,
    },
  ];

  return (
    <div className={(classes.root, "pb30")}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          indicatorColor="primary"
          textColor="primary"
          TabIndicatorProps={{ style: { display: "none" } }}
        >
          {tabsList.map((text, index) => (
            <Tab
              label={text.name}
              key={index}
              {...a11yProps(index)}
              style={{ borderRadius: 20 }}
            />
          ))}
        </Tabs>
      </AppBar>
      {tabsList.map((object, index) => {
        return (
          <TabPanel value={value} index={index} key={"tab" + index}>
            {React.createElement(object.child, { handleChange: handleChange })}
          </TabPanel>
        );
      })}
    </div>
  );
}
export default PortfolioReview;
